<template>
  <div class="slider-container">
    <img src="../../img/slider_accueil/fleche.svg" alt="" class="left-arrow arrow" @click="prev">
    <transition name="fade">
      <app-accueil-slide-1 :imageName="slides[0].imageName" v-if="slides[0].active"></app-accueil-slide-1>
      <app-accueil-slide-2 :imageName="slides[1].imageName" v-if="slides[1].active"></app-accueil-slide-2>
      <app-accueil-slide-3 :imageName="slides[2].imageName" v-if="slides[2].active"></app-accueil-slide-3>
      <app-accueil-slide-4 :imageName="slides[3].imageName" v-if="slides[3].active"></app-accueil-slide-4>
      <app-accueil-slide-5 :imageName="slides[4].imageName" v-if="slides[4].active"></app-accueil-slide-5>
    </transition>
    <img src="../../img/slider_accueil/fleche.svg" alt="" class="right-arrow arrow" @click="next">
    <div class="point-container flex-row">
      <div class="rond" v-for="(slide, index) in slides" @click="goTo(index)" :class="[{'active': slide.active}]"></div>
    </div>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

    import Slide from "./Slide";
    import Slide2 from "./Slide2";
    import Slide3 from "./Slide3";
    import Slide4 from "./Slide4";
    import Slide5 from "./Slide5";
  import image1 from "../../img/slider_accueil/reduct/reduct_Paris.jpg";
  import image2 from "../../img/slider_accueil/reduct/reduct_Lyon.jpg";
  import image3 from "../../img/slider_accueil/reduct/reduct_Nantes.jpg";
  import image4 from "../../img/slider_accueil/reduct/reduct_Metz.jpg";
  import image5 from "../../img/slider_accueil/reduct/reduct_Marseille_plus.jpg";

  export default {
      data() {
          return {
            slides: [
                {
                    id: 1,
                    imageName: image1,
                    active: true,
                },
                {
                    id: 2,
                    imageName: image2,
                    active: false,
                },
                {
                    id: 3,
                    imageName: image3,
                    active: false,
                },
                {
                    id: 4,
                    imageName: image4,
                    active: false,
                },
                {
                    id: 5,
                    imageName: image5,
                    active: false,
                },
            ],
              inactiveTimeToAutoSlide: 7000, // multiple de 500
              timeBeforeSlideAuto: 0,
              refreshTime: 500
          }
      },
      methods: {
          autoSlide() {
              const self = this;
              this.intervale = setInterval(function(){
                  if (self.timeBeforeSlideAuto < (new Date()).getTime()) {
                      self.next();
                  }
              }, this.refreshTime);
          },
          action() {
              this.timeBeforeSlideAuto = this.inactiveTimeToAutoSlide + (new Date()).getTime();
          },
          goTo(index) {
              this.action();
              this.removeAll();
              this.slides[index].active = true;
          },
          getActivePosition() {
              return this.slides.findIndex(this.activeFilter);
          },
          activeFilter(slide) {
              return slide.active;
          },
          getLength() {
              return this.slides.length;
          },
          removeAll() {
              this.slides[this.getActivePosition()].active = false;
          },
          next() {
              this.action();
              let nextIndex = (this.getActivePosition()+1 == this.getLength()) ? 0 : this.getActivePosition()+1 ;
              this.removeAll();
              this.slides[nextIndex].active = true;
          },
          prev() {
              this.action();
              let prevIndex = (this.getActivePosition() == 0) ? this.getLength()-1 : this.getActivePosition()-1 ;
              this.removeAll();
              this.slides[prevIndex].active = true;
          },
          changeTo(pageName) {
              menuBus.$emit('changePage', pageName);
          }
      },
      mounted() {
          this.timeBeforeSlideAuto = this.inactiveTimeToAutoSlide + (new Date()).getTime();
          this.autoSlide();
          menuBus.$on('changePage', (pageName, idName) => {
              this.menuShowed = false;
          });
      },
    components: {
        'app-accueil-slide-1': Slide,
        'app-accueil-slide-2': Slide2,
        'app-accueil-slide-3': Slide3,
        'app-accueil-slide-4': Slide4,
        'app-accueil-slide-5': Slide5,
    }
  }
</script>

<style scoped>
  .slider-container {
    position: relative;
    height: 100vh;
    min-height: 800px;
    width: 100%;
    background-color: black;
    z-index: 10;
    overflow-y: hidden;
  }
  .arrow {
    position: absolute;
    z-index: 20;
    height: 30px;
    top: calc(50% + 100px);
    transform: translateY(-50%);
    cursor: pointer;
  }
  .left-arrow {
    left: 50px;
  }
  .right-arrow {
    right: 50px;
    transform: translateY(-50%) rotate(180deg);
  }
  .point-container {
    display: none;
    z-index: 100;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  @media (max-width: 800px) {
    .arrow {
      display: none;
    }
    .point-container {
      display: flex;
      height: 50px;

      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .rond {
      height: 15px;
      width: 15px;
      margin: 0 5px;
      border-radius: 50%;
      background-color: white;
      opacity: 0.5;
      cursor: pointer;
    }
    .rond.active {
      opacity: 1;
    }
  }

  /* Mobile */
  @media (max-width: 500px) {
    .slider-container {
      min-height: 100vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/Slider.vue